import { Box, RadioGroup } from '@mui/material';
import { AppGlobalClassKeys } from 'app/appGlobalStyles';
import { MprcContainer } from 'components';
import { MprcRadio } from 'components/MprcRadio';
import { MprcSeparatorBarText } from 'components/MprcSeparatorBarText';
import { ClassroomViewDto } from 'generated/CoreApi_v1';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ITraininRegistrationProps } from 'views/lms/student/Registration';
import { RegistrationDefaultHighlights } from 'views/lms/student/Registration/components/RegistrationDefaultHighlights';

///////////////////////////////////////////////////////////////////////////////

interface IProps extends ITraininRegistrationProps {
    classrooms: ClassroomViewDto[];
    selectedClassroom: number;
    onChangeClassroom: (index: number) => void;
}

export const RegistrationClassroomsView = ({ classrooms, selectedClassroom, onChangeClassroom }: IProps) => {
    const { t } = useTranslation("lms");

    return (
        <Box height="100%">
            <MprcContainer>
                <Box
                    maxHeight={120}
                    sx={{ mb: 1 }}
                    overflow="auto"
                    className={AppGlobalClassKeys.thinScrollbar}
                >
                    <RegistrationDefaultHighlights {...classrooms[selectedClassroom]} />
                </Box>
            </MprcContainer>

            <MprcContainer>
                <MprcSeparatorBarText title={t("Training.Classroom.ChooseClassroomBarText")} />
            </MprcContainer>
            <Box padding={1} >
                <RadioGroup
                    value={selectedClassroom}
                    onChange={(e, value) => onChangeClassroom(parseInt(value))}
                >
                    {
                        classrooms.map((clr, index) => {
                            return (
                                <MprcRadio
                                    key={index}
                                    value={index}
                                    label={clr.name}
                                />
                            );
                        })
                    }
                </RadioGroup>
            </Box>
        </Box>
    );
};
